import { render, staticRenderFns } from "./HaoMaZhuShou.vue?vue&type=template&id=70c4f62a&scoped=true&"
import script from "./HaoMaZhuShou.vue?vue&type=script&lang=js&"
export * from "./HaoMaZhuShou.vue?vue&type=script&lang=js&"
import style0 from "./HaoMaZhuShou.vue?vue&type=style&index=0&id=70c4f62a&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "70c4f62a",
  null
  
)

export default component.exports